import { JOB_ROLES, USAGE_PURPOSES, COUNTRIES } from './constants';

export default function OnboardingForm({
    step,
    jobRole,
    countryCode,
    usagePurpose,
    onSelectRole,
    onCountryChange,
    onSelectPurpose,
    onContinue,
    error
}) {
    return (
        <>
            {step === 'role' && (
                <>
                    <h1>What&apos;s your role?</h1>
                    <p className="auth-subtitle">This helps us understand how teams use RuleStore Studio.</p>
                    <div className="auth-choice-grid">
                        {JOB_ROLES.map(role => (
                            <button
                                key={role}
                                type="button"
                                className={`auth-choice ${jobRole === role ? 'is-selected' : ''}`}
                                onClick={() => onSelectRole(role)}
                            >
                                {role}
                            </button>
                        ))}
                    </div>
                    {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                    <button type="button" className="btn-primary auth-submit" disabled={!jobRole} onClick={onContinue}>Continue</button>
                </>
            )}

            {step === 'country' && (
                <>
                    <h1>Where are you based?</h1>
                    <p className="auth-subtitle">We guessed this from your location. Correct it if needed.</p>
                    <select className="input-field" value={countryCode} onChange={e => onCountryChange(e.target.value)}>
                        <option value="">Select a country</option>
                        {!COUNTRIES.some(country => country.code === countryCode) && countryCode && (
                            <option value={countryCode}>{countryCode}</option>
                        )}
                        {COUNTRIES.map(country => (
                            <option key={country.code} value={country.code}>{country.name}</option>
                        ))}
                    </select>
                    {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                    <button type="button" className="btn-primary auth-submit" disabled={!countryCode} onClick={onContinue}>Continue</button>
                </>
            )}

            {step === 'purpose' && (
                <>
                    <h1>What will you use RuleStore Studio for?</h1>
                    <p className="auth-subtitle">Pick the option that best matches your work.</p>
                    <div className="auth-choice-stack">
                        {USAGE_PURPOSES.map(purpose => (
                            <button
                                key={purpose}
                                type="button"
                                className={`auth-choice ${usagePurpose === purpose ? 'is-selected' : ''}`}
                                onClick={() => onSelectPurpose(purpose)}
                            >
                                {purpose}
                            </button>
                        ))}
                    </div>
                    {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                    <button type="button" className="btn-primary auth-submit" disabled={!usagePurpose} onClick={onContinue}>Continue</button>
                </>
            )}
        </>
    );
}
